import React from 'react'
import PreviousMonthComparison from '../charts/PreviousMonthComparison'
import { MainDiv } from '../Default/MainDiv'
import { Combined } from './Combined'
import { CompanyRealTimeBlocks } from './CompanyRealTimeBlocks'
import { BuildingRealTimeBlocks } from './BuildingRealTimeBlocks'

export const Dashboard=(props) =>{
  

let headData=[
    {
      name:"Enter Count",
      tableHeadData:[
        "Floor",
        "FootFall",
        "%"

      ],
      role:"MallFootFall"
    },{
      name:"Person Occupancy",
      tableHeadData:[
        "Floor",
        "Occupancy",
        "%"

      ],
      role:"MallOccupancy"
    },
   
  ]
 return (
    <>
  <MainDiv>

{props.type ==="company" && <CompanyRealTimeBlocks key="realtime" type={props.type}  headData={headData}  />}  
{props.type !=="company" && <BuildingRealTimeBlocks key="realtime" type={props.type}  headData={headData}  />}  

    
    {/* <Combined/> */}
    {/* <PreviousMonthComparison /> */}
   </MainDiv> 
    </>
    
  )

  
}
